import React from 'react'

interface MetaTagsProps {
	title: string;
	url: string;
	twitterCard?: 'summary' | 'summary_large_image' | 'app' | 'player';
	description?: string;
	image?: string;
}

export default function MetaTags({twitterCard = 'summary_large_image', ...props}: MetaTagsProps) {
	return <>
		<meta name="title" content={props.title}/>
		{props.description && <meta name="description" content={props.description}/>}

		<meta property="og:type" content="website"/>
		<meta property="og:url" content={props.url}/>
		<meta property="og:title" content={props.title}/>
		{props.description && <meta property="og:description" content={props.description}/>}
		{props.image && <meta property="og:image" content={props.image}/>}

		<meta property="twitter:card" content={twitterCard}/>
		<meta property="twitter:url" content={props.url}/>
		<meta property="twitter:title" content={props.title}/>
		{props.description && <meta property="twitter:description" content={props.description}/>}
		{props.image && <meta property="twitter:image" content={props.image}/>}
	</>
}
